import { lazy } from 'react';



const TempScreenConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/temp',
      component: lazy(() => import('./TempScreen')),
    },
  ],
};

export default TempScreenConfig
